import React, { useEffect, useState } from "react";
import { Button, Card, CardBody } from "reactstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { BaseUrl, getCms } from "../../services/Url";
import DOMPurify from "dompurify";

export const Terms = () => {
  const [data, setData] = useState();

  const getCMSAbout = async () => {
    let data = {
      name: "Term and Condition",
    };
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + getCms;

    let response = await fetch(CompleteUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const jsonData = await response.json();
    console.log(jsonData);
    if (jsonData.data != null) {
      setData(jsonData?.data);
    }
  };

  useEffect(() => {
    getCMSAbout();
  }, []);

  function createMarkup(html) {
    return {
      __html: DOMPurify.sanitize(html),
    };
  }

  return (
    <section className="section py-sm-5 py-4">
      <div className="container">
        <div className="row">
          <div id="primary" className="content-area col-md-8 mx-auto">
            <div id="content" className="site-content" role="main">
              <article>
                <header className="entry-header">
                  <div className="term_logo">
                    <img
                      src="/static/media/logo.e863bd4fea3d359928aa.png"
                      alt="popular"
                      loading="lazy"
                    />
                  </div>
                  <h1
                    className="entry-title text-center mb-3"
                    style={{ color: "#02387b" }}
                  >
                    Terms & Conditions
                  </h1>
                </header>

                <div
                  className="entry-content"
                  dangerouslySetInnerHTML={createMarkup(data?.content)}
                ></div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
